'use strict';
const angular = require('angular');

/*@ngInject*/
export function WorkOrderTicketsService($resource) {
  return $resource('/api/workorders/:id', {
    name: '@_id'
  },{
    letter: {
      method: 'GET',
      url: "/api/workorders/:id/letter",
    },
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    getByVendor: {
      method: 'GET',
      url: "/api/workorders/vendor/:id",
      isArray: true
    },
    getByProperty: {
      method: 'GET',
      url: "/api/workorders/property/:id",
      isArray: true
    },
    getByCommunity: {
      method: 'GET',
      url: "/api/workorders/community/:id",
      isArray: true
    },
    addAttachments: {
      method: 'PUT',
      url: "/api/workorders/:id/attachments"
    },
    createPDFAndAttach: {
      method: 'GET',
      url: "/api/workorders/:id/attach-letter"
    },
    sendAttachmentMail: {
      method: 'POST',
      url: "/api/workorders/:id/attachments/mail"
    }
  });
}


export default angular.module('conduu.WorkOrderTicketsService', [])
  .factory('WorkOrderTicketsService', WorkOrderTicketsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/workorder-tickets/workorder-tickets.service.js